<template>
	 <div>
		<b-row class="neu-cards-ctn landing-cnt" cols="1" cols-xl="4">
			<PatientPanelServiceBlock id="new-consultation" :visible="showSearchBlock" :title="inCompanies ? $t('patient-panel.get-new-consultation') : $t('patient-panel.get-new-consultation-or-service')" path="/patient/panel-search" img="/static-appopensalud/img/icons/morillas-svg-icons/primary/medic.svg" />
			<PatientPanelServiceBlock id="next-consultations" visible :title="$t('patient-panel.go-to-next-consultations')" path="/patient/appointments/next" img="/static-appopensalud/img/icons/next-appointments.svg" />
			<PatientPanelServiceBlock id="past-consultations" visible :title="$t('patient-panel.go-to-past-consultation')" path="/patient/appointments/past" img="/static-appopensalud/img/icons/past-appointments.svg" />
		</b-row>
	</div>
</template>

<script>
import PatientPanelServiceBlock from '@/components/PatientPanelServiceBlock.vue'
import { inOpensalud360 } from '@/constants/platformNames'

export default {
	components: {
		PatientPanelServiceBlock
	},
	computed: {
		showSearchBlock () {
			return !inOpensalud360() || this.$store.getters['session/search360Active']
		},
		inCompanies () {
			return inOpensalud360()
		}
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/AppointmentsPanelMenu.vue